// export const BASE_URL = "https://a.yetitech.com.np";
export const BASE_URL = "https://raksichaiyo.com";
